// Common shell for widget cards. Matches the existing `cc-card` chrome
// (head + sub) and gives every widget consistent padding so the grid is
// visually uniform without each widget repeating boilerplate.

import type { ReactNode } from "react";

interface Props {
  title?: string;
  sub?: string;
  children: ReactNode;
  /** Optional inline action (e.g. "Generate" CTA in the header). */
  action?: ReactNode;
}

export function WidgetCard({ title, sub, children, action }: Props) {
  return (
    <div className="cc-card cc-widget">
      {(title || sub || action) && (
        <div
          className="cc-card-head"
          style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
        >
          <div style={{ display: "flex", alignItems: "baseline", gap: 6, minWidth: 0 }}>
            {title && (
              <div className="cc-card-title" style={{ whiteSpace: "nowrap" }}>
                {title}
              </div>
            )}
            {sub && <div className="cc-card-sub">· {sub}</div>}
          </div>
          {action}
        </div>
      )}
      <div style={{ padding: "14px 18px 16px" }}>{children}</div>
    </div>
  );
}
